<template>
  <div id="login">
    <div class="van-hairline--bottom background_color_d6f1ec font_weight_bold" style="z-index: 1;" v-show="$vuetify.breakpoint.smAndDown">
      <v-row gutter="10" type="flex" align="center" justify="space-between">
        <v-col cols="2" />
        <v-col cols="8">
          <div class="background_color_d6f1ec van-nav-bar">
            <div class="van-ellipsis van-nav-bar__title">{{ $t("login.signInByEmail") }}</div>
          </div>
        </v-col>
        <v-col cols="2" class="margin_top_12" v-show="$enableShoppingCart">
          <!-- <div class="van-nav-bar__right" style="top: 15px;">
            <wc-tabbar-cart />
          </div>-->
          <!-- <wc-tabbar-cart /> -->
        </v-col>
      </v-row>
    </div>

    <div class="content2">
      <img src="../assets/img/icon_logo_2.png" class="logo_banner" />

      <div class="login_account_bar">
        <v-text-field class="input" v-model="email" :label="$t('login.email')" prepend-icon="mdi-email"> </v-text-field>
        <v-text-field
          class="input"
          v-model="pwd"
          :type="showPassword ? 'text' : 'password'"
          :label="$t('login.password')"
          prepend-icon="mdi-lock"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>

        <!-- 
        <div class="login_bar">
          <img src="../assets/img/icon_yx.png" class="img-text-top-middle" />
          <input type="text" class="input font_14" :placeholder="$t('login.email')" v-model="email" />
        </div>
        <div class="login_bar">
          <img src="../assets/img/icon_mima.png" class="img-text-top-middle" />
          <input type="password" class="input font_14" :placeholder="$t('login.password')" v-model="pwd" />
        </div>
         -->
      </div>

      <div class="padding_20">
        <v-row>
          <v-col>
            <div class="toForgetPwd" @click="toForgetPwd">{{ $t("login.forgotPwd") }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn class="btn_login" outlined rounded @click="toLogin"> {{ $t("login.signIn") }} </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn class="btn_login" outlined rounded @click="toRegister"> {{ $t("login.register") }} </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      email: "",
      pwd: "",
      showPassword: false,
    };
  },
  mounted() {
    if (!this.$enableMembership) this.$router.replace({ name: "home" });
    this.$parent.curTab = 4;
    this.loadStates();
  },
  methods: {
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      if (this.$store.state.member) {
        if ("eMailAddress" in this.$store.state.member) this.email = this.$store.state.member.eMailAddress;
      }
    },
    // ------------------------------------------------------------------------ weChatLogin
    /*
    //微信登录
    weChatLogin() {
      let $this = this;
      dsBridge.call("third_party_login", "1");
      dsBridge.register("third_msg", function(res) {
        $this.$ajax2
          .post(
            "wechatLogin",
            { openid: JSON.parse(res).openid },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              }
            }
          )
          .then(function(rpdata) {
            if (rpdata.data.meta.code == "200") {
              $this.$toast({
                message: $this.$t("lang.loginSuccess"),
                position: "bottom"
              });
              $this.$router.push({ name: "home" });
            } else {
              $this.$toast({
                message: rpdata.data.meta.msg,
                position: "bottom"
              });
            }
          })
          .catch(function(err) {});
      });
    },
    */
    // ------------------------------------------------------------------------ toRegister
    toRegister() {
      this.$router.push({ name: "register" });
    },
    // ------------------------------------------------------------------------ toForgetPwd
    toForgetPwd() {
      this.$router.push({ name: "recoverPswd" });
    },
    // ------------------------------------------------------------------------ toLogin
    toLogin() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        email: $this.email,
        password: $this.pwd,
      };

      $this.$ajax2
        .post("ValidateMember", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.$store.commit("member", rpdata.data.data);
            $this.$toast({
              message: $this.$t("login.Success"),
              position: "bottom",
            });
            $this.$router.push({ name: "home" });
          } else {
            $this.$store.commit("member", {});
            $this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
  },
};
</script>

<style>
#login .btn_login {
  color: indigo;
  text-transform: none !important;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}
#login .toForgetPwd {
  font-size: 12px;
  float: right;
  padding: 7px 20px;
}
#login .toRegister {
  font-size: 12px;
  float: left;
  padding: 7px 20px;
}
#login .input {
  width: 90%;
  border: 0;
  padding: 0 20px;
}
#login .login_account_bar {
  margin: 15% 5% 5% 5%;
}
#login .login_bar {
  padding: 15px 10px;
  border-bottom: 1px solid #eeeeee;
}
#login .logo {
  width: 20%;
  display: block;
  margin: 0 auto;
  padding-top: 40px;
}
#login .logo_banner {
  width: 80%;
  display: block;
  margin: 0 auto;
  padding-top: 20px;
}
#login {
  background-color: white;
  /* height: -webkit-fill-available; */
}
</style>
